"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5796],{

/***/ 25796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Page; },
/* harmony export */   "g": function() { return /* binding */ AuthLayout; }
/* harmony export */ });
/* harmony import */ var _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87379);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83852);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22318);
/* harmony import */ var _lib_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54442);
/* harmony import */ var _context_registerCompanyStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88117);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18969);
/* harmony import */ var _components_Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74815);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40570);
/* harmony import */ var _Error__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89649);
/* harmony import */ var _Banner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25310);














function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        "px 0 0 0;\n    min-height: auto;\n    background-image: none;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: calc(2rem + ",
        "px) 0 2rem 0;\n  min-height: 100vh;\n  background-color: ",
        ";\n  // https://unsplash.com/photos/VLPUm5wP5Z0\n  background-image: linear-gradient(to right, ",
        ", ",
        "),\n    url(/constle_hero_background.jpg);\n  background-position: center 20%;\n  background-size: cover;\n  box-sizing: border-box;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: 1.5rem;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0;\n    padding: 2rem;\n    max-width: 100%;\n    width: 100%;\n    border-bottom: 2px solid ",
        ";\n    border-radius: 0px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  margin-bottom: 1.5rem;\n  padding: 2.5rem;\n  max-width: ",
        "px;\n\n  ",
        "\n\n  ",
        "\n\n  .MuiStepper-root {\n    padding: 2.5rem 0 0.8rem 0;\n  }\n\n  .MuiStepLabel-iconContainer {\n    padding-right: 1rem;\n  }\n\n  ",
        " {\n    &:not(.error) {\n      margin-bottom: 2rem;\n    }\n\n    &.error {\n      margin-top: 1rem;\n    }\n  }\n\n  .MuiStepLabel-label {\n    font-weight: 500;\n    color: ",
        ";\n  }\n\n  .MuiStepContent-root {\n    padding-left: 1.75rem;\n    .MuiTypography-body2 {\n      opacity: 0.8;\n    }\n  }\n\n  .MuiSvgIcon-root text {\n    font-weight: bold;\n    fill: ",
        ";\n  }\n\n  > .MuiTypography-body2 {\n    margin-bottom: 2rem;\n    opacity: 0.8;\n  }\n\n  hr {\n    margin-top: 2rem;\n    margin-left: -2.5rem;\n    width: calc(100% + 5rem);\n    height: 2px;\n    background-color: ",
        ";\n    border: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  .MuiFormControl-root:not(:first-of-type) {\n    margin-top: 1rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  margin: 2rem 0 0 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0;\n    padding: 2rem;\n    width: 100%;\n    max-width: none;\n    background-color: ",
        ";\n    border-radius: 0;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding: 0 2.5rem 0 2.5rem;\n  max-width: ",
        "px;\n  background-color: transparent;\n  box-shadow: none;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
var Page = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5d110f52-0"
})(_templateObject1(), _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .navbarHeight */ .zP, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.secondary */ .Il.secondary, (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.4, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.secondary */ .Il.secondary), (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.8, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.secondary */ .Il.secondary), _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)(_templateObject(), _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .navbarHeight */ .zP, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background)));
var Content = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5d110f52-1"
})(_templateObject4(), _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .cardStyles */ .F, function(props) {
    return props.$width || 600;
}, function(param) {
    var footer = param.footer;
    return footer && (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)(_templateObject2());
}, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)(_templateObject3(), _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background)), _Banner__WEBPACK_IMPORTED_MODULE_10__/* .BannerBox */ .C, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.black */ .Il.black, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.background */ .Il.background);
var ContentMain = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5d110f52-2"
})(_templateObject5());
var Control = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5d110f52-3"
})(_templateObject6());
var Footer = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5d110f52-4"
})(_templateObject8(), _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .cardStyles */ .F, function(props) {
    return props.$width || 600;
}, _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.small */ .cy.small((0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)(_templateObject7(), _components_Theme__WEBPACK_IMPORTED_MODULE_7__/* .Color.white */ .Il.white)));
var AuthLayout = function(param) {
    var title = param.title, icon = param.icon, description = param.description, _primaryAction = param.primaryAction, primaryAction = _primaryAction === void 0 ? 'Seuraava' : _primaryAction, _secondaryAction = param.secondaryAction, secondaryAction = _secondaryAction === void 0 ? 'Keskeyt\xe4' : _secondaryAction, _stepper = param.stepper, stepper = _stepper === void 0 ? null : _stepper, _control = param.control, control = _control === void 0 ? null : _control, _footer = param.footer, footer = _footer === void 0 ? null : _footer, tmp = param.error, externalError = tmp === void 0 ? null : tmp, _errorElement = param.errorElement, errorElement = _errorElement === void 0 ? null : _errorElement, _disableAfterSuccess = param.disableAfterSuccess, disableAfterSuccess = _disableAfterSuccess === void 0 ? false : _disableAfterSuccess, width = param.width, onValidateStep = param.onValidateStep, onCompleteStep = param.onCompleteStep, onCancelStep = param.onCancelStep, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,_lib_state__WEBPACK_IMPORTED_MODULE_4__/* .useScopedState */ .S)(_context_registerCompanyStore__WEBPACK_IMPORTED_MODULE_5__/* .registerCompanyState */ .lw, []), doClearRegisterCompanyState = ref.doClearState;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isDisabled = ref3[0], setIsDisabled = ref3[1];
    var handleValidate = function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var state;
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        if (!onValidateStep) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 4;
                        return onValidateStep();
                    case 4:
                        state = _ctx.sent;
                        if (!(state === true)) {
                            _ctx.next = 9;
                            break;
                        }
                        {
                            handleNext();
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        setError(state);
                        setIsLoading(false);
                        return _ctx.abrupt("return");
                    case 12:
                        _ctx.next = 15;
                        break;
                    case 14:
                        {
                            handleNext();
                        }
                    case 15:
                        if (disableAfterSuccess) {
                            setError(null);
                            setIsLoading(false);
                            setIsDisabled(true);
                        }
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleValidate() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNext = function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!onCompleteStep) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", onCompleteStep());
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleNext() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelButtonClick = function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!onCancelStep) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", onCancelStep());
                    case 2:
                        _ctx.next = 4;
                        return doClearRegisterCompanyState();
                    case 4:
                        router.push('/');
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCancelButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNextButtonClick = function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleValidate();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleNextButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Page, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Content, {
                footer: !!footer,
                $width: width,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_6__/* .Header */ .h, {
                        icon: icon,
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        variant: "body2",
                        children: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentMain, {
                        children: children
                    }),
                    errorElement ? errorElement : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Error__WEBPACK_IMPORTED_MODULE_9__/* .Error */ .j, {
                        error: externalError !== null && externalError !== void 0 ? externalError : error
                    }),
                    !control && control !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Control, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                                variant: "text",
                                color: "default",
                                disabled: isLoading || isDisabled,
                                onClick: handleCancelButtonClick,
                                children: secondaryAction
                            }),
                            primaryAction !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                                loading: isLoading,
                                disabled: isLoading || isDisabled,
                                onClick: handleNextButtonClick,
                                children: primaryAction
                            })
                        ]
                    }),
                    !!control && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Control, {
                        children: control
                    }),
                    stepper !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}),
                            stepper
                        ]
                    })
                ]
            }),
            !!footer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Footer, {
                $width: width,
                children: footer
            })
        ]
    }));
};


/***/ }),

/***/ 49219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ handleBasicErrors; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44012);



var handleBasicErrors = function(param) {
    var status = param.status, _catchAll = param.catchAll, catchAll = _catchAll === void 0 ? false : _catchAll;
    if (status === 'bad request') {
        return {
            status: status,
            error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: "unknownError",
                defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
            })
        };
    }
    if (status === 'rate limit') {
        return {
            status: status,
            error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: "error.rateLimit",
                defaultMessage: "Tietokanta on erityisen kiireinen. Odota muutama minuutti ja yrit\xe4 uudelleen…"
            })
        };
    }
    if (catchAll) {
        if (status !== 'ok') {
            return {
                status: status,
                error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    id: "unknownError",
                    defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                })
            };
        }
    }
    return false;
};


/***/ }),

/***/ 88117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lw": function() { return /* binding */ registerCompanyState; },
/* harmony export */   "n8": function() { return /* binding */ useRegisterCompanyStep; }
/* harmony export */ });
/* unused harmony exports registerCompanyStateDefaults, doClearState, doIdentifyRedirect, doIdentifyUser, doLinkCompany, doSendIdentificationForm, doSendCompanyForm, useRegisterCompanyState, registerCompanySteps */
/* harmony import */ var _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14894);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14316);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26482);
/* harmony import */ var _lib_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54442);
/* harmony import */ var _common_Constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72916);
/* harmony import */ var _useUser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95460);
/* harmony import */ var _loginContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9000);
/* harmony import */ var _basicErrorHandling__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49219);











function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var registerCompanyStateDefaults = {
    userFirstNames: '',
    userLastName: '',
    userBirthdate: '',
    isIdentified: false,
    userCountry: '',
    userPhone: '',
    userIdentificationConsent: false,
    isIdentificationFormSent: false,
    companyID: null,
    companyBusinessID: '',
    companyIdentificationConsent: false,
    isCompanyLinked: false,
    companyName: '',
    companyCountry: '',
    companyAddress: '',
    companySales: '',
    isCompanyLinkFormSent: false,
    sessionCode: '',
    sessionStateID: _common_Constants__WEBPACK_IMPORTED_MODULE_4__/* .RegisterCompanySessionState.PENDING_AUTHENTICATION */ .w_.PENDING_AUTHENTICATION
};
/**
 * Clear the state
 */ var doClearState = function(set, get) {
    return _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    set(registerCompanyStateDefaults);
                    return _ctx.abrupt("return", {
                        status: 'ok'
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
/**
 * Start authentication process
 */ var doIdentifyRedirect = function() {
    return _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, status, teliaFormUrl;
        return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .nextApiRequest */ .Qd)("/api/v1/www/auth/telia/pre-auth");
                case 2:
                    ref = _ctx.sent;
                    status = ref.status;
                    teliaFormUrl = ref.teliaFormUrl;
                    if (!(status !== 'ok')) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: status,
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "unknownError",
                            defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                        })
                    });
                case 7:
                    return _ctx.abrupt("return", {
                        status: 'ok',
                        teliaFormUrl: teliaFormUrl
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var doIdentifyUser = function(set) {
    return (function() {
        var _ref = _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _userFirstNames, userFirstNames, _userLastName, userLastName, userBirthdate, sessionCode;
            return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _userFirstNames = param.userFirstNames, userFirstNames = _userFirstNames === void 0 ? '' : _userFirstNames, _userLastName = param.userLastName, userLastName = _userLastName === void 0 ? '' : _userLastName, userBirthdate = param.userBirthdate, sessionCode = param.sessionCode;
                        if (sessionCode) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            status: 'bad request',
                            error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                id: "unknownError",
                                defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                            })
                        });
                    case 3:
                        _ctx.next = 5;
                        return (0,_loginContext__WEBPACK_IMPORTED_MODULE_6__/* .validateSession */ .je)();
                    case 5:
                        // Clear old state && save to state
                        set(_objectSpread({}, registerCompanyStateDefaults, {
                            userFirstNames: userFirstNames,
                            userLastName: userLastName,
                            userBirthdate: userBirthdate || '',
                            sessionCode: sessionCode,
                            isIdentified: true,
                            sessionStateID: _common_Constants__WEBPACK_IMPORTED_MODULE_4__/* .RegisterCompanySessionState.PENDING_COMPANY */ .w_.PENDING_COMPANY
                        }));
                        return _ctx.abrupt("return", {
                            status: 'ok'
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    })();
};
var doLinkCompany = function(set, get) {
    return _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, companyBusinessID, companyIdentificationConsent, sessionCode, _ref, status, companyData, errorStatus, companyID, companyName, sessionStateID;
        return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = get(), companyBusinessID = ref.companyBusinessID, companyIdentificationConsent = ref.companyIdentificationConsent, sessionCode = ref.sessionCode;
                    if (sessionCode) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'bad request',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "unknownError",
                            defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                        })
                    });
                case 3:
                    if (companyIdentificationConsent) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'company consent missing',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.companyConsentMissing",
                            defaultMessage: "Vakuus sy\xf6tetyn tiedon aitoudesta on pakollinen."
                        })
                    });
                case 5:
                    if (!(!companyBusinessID || !/^[\d]{7}-[\d]$/.test(companyBusinessID.trim()))) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'invalid company tax id',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.invalidCompanyTaxId",
                            defaultMessage: "Virheellinen Y-tunnus. Tarkista ett\xe4 Y-tunnus on sy\xf6tetty oikein ja ett\xe4 se on oikeassa muodossa (1234567-8)."
                        })
                    });
                case 7:
                    _ctx.next = 9;
                    return (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .nextApiRequest */ .Qd)("/api/v1/www/register-company/company-id", {
                        businessID: companyBusinessID.trim(),
                        sessionCode: sessionCode
                    }, {
                        delay: 2000
                    });
                case 9:
                    _ref = _ctx.sent;
                    status = _ref.status;
                    companyData = _objectWithoutProperties(_ref, [
                        "status"
                    ]);
                    errorStatus = (0,_basicErrorHandling__WEBPACK_IMPORTED_MODULE_7__/* .handleBasicErrors */ .i)({
                        status: status
                    });
                    if (!errorStatus) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return", errorStatus);
                case 15:
                    if (!(status === 'unknown company')) {
                        _ctx.next = 17;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: status,
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.companyTaxIdUnknown",
                            defaultMessage: "Y-tunnusta ei viel\xe4 l\xf6ydy Constlen tietokannasta. Voit pyyt\xe4\xe4 sen lis\xe4\xe4mist\xe4 lomakkeen avulla."
                        })
                    });
                case 17:
                    if (!(status === 'already registered')) {
                        _ctx.next = 19;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: status,
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.companyTaxIdExists",
                            defaultMessage: "Y-tunnus on jo rekister\xf6ity Constleen. Ole hyv\xe4 ja kirjaudu sis\xe4\xe4n. Jos olet unohtanut tunnuksesi, ota yhteytt\xe4 tukeen."
                        })
                    });
                case 19:
                    if (!(status !== 'ok')) {
                        _ctx.next = 21;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: status,
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "unknownError",
                            defaultMessage: "Jokin meni vikaan, yrit\xe4 my\xf6hemmin uudelleen…"
                        })
                    });
                case 21:
                    companyID = companyData.companyID, companyName = companyData.companyName, sessionStateID = companyData.sessionStateID;
                    // Save to state
                    set({
                        companyID: companyID,
                        companyBusinessID: companyBusinessID,
                        companyName: companyName,
                        isCompanyLinked: true,
                        sessionStateID: sessionStateID
                    });
                    _ctx.next = 25;
                    return (0,_loginContext__WEBPACK_IMPORTED_MODULE_6__/* .validateSession */ .je)();
                case 25:
                    return _ctx.abrupt("return", {
                        status: 'ok'
                    });
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
/**
 * Validate company information on state
 */ 
var doSendIdentificationForm = function(set, get) {
    return _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, userFirstNames, userLastName, userBirthdate, userCountry, userPhone, userIdentificationConsent, identificationRequestPayload, _ref, status, identificationData, errorStatus, sessionCode;
        return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = get(), userFirstNames = ref.userFirstNames, userLastName = ref.userLastName, userBirthdate = ref.userBirthdate, userCountry = ref.userCountry, userPhone = ref.userPhone, userIdentificationConsent = ref.userIdentificationConsent;
                    if (!(!userFirstNames || !userLastName || !userBirthdate || !userCountry || !userPhone)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'bad request',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.identificationFormInformationMissing",
                            defaultMessage: "T\xe4yt\xe4 kaikki kent\xe4t ennen lomakkeen l\xe4hett\xe4mist\xe4."
                        })
                    });
                case 3:
                    if (userIdentificationConsent) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'identification consent missing',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.identificationFormConsentMissing",
                            defaultMessage: "Vakuus sy\xf6tetyn tiedon aitoudesta on pakollinen."
                        })
                    });
                case 5:
                    identificationRequestPayload = {
                        firstNames: userFirstNames,
                        lastName: userLastName,
                        birthdate: userBirthdate,
                        country: userCountry,
                        phone: userPhone
                    };
                    _ctx.next = 8;
                    return (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .nextApiRequest */ .Qd)("/api/v1/www/register-company/identification-form", identificationRequestPayload, {
                        delay: 2000
                    });
                case 8:
                    _ref = _ctx.sent;
                    status = _ref.status;
                    identificationData = _objectWithoutProperties(_ref, [
                        "status"
                    ]);
                    errorStatus = (0,_basicErrorHandling__WEBPACK_IMPORTED_MODULE_7__/* .handleBasicErrors */ .i)({
                        status: status
                    });
                    if (!errorStatus) {
                        _ctx.next = 14;
                        break;
                    }
                    return _ctx.abrupt("return", errorStatus);
                case 14:
                    if (!(status !== 'ok')) {
                        _ctx.next = 16;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'identification failed',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.identificationFormFailed",
                            defaultMessage: "Tunnistautuminen lomakkeella ep\xe4onnistui. Ole hyv\xe4 ja yrit\xe4 uudelleen…"
                        })
                    });
                case 16:
                    sessionCode = identificationData.sessionCode;
                    _ctx.next = 19;
                    return (0,_loginContext__WEBPACK_IMPORTED_MODULE_6__/* .validateSession */ .je)();
                case 19:
                    // Save to state
                    set({
                        isIdentificationFormSent: true,
                        sessionCode: sessionCode,
                        sessionStateID: _common_Constants__WEBPACK_IMPORTED_MODULE_4__/* .RegisterCompanySessionState.PENDING_COMPANY */ .w_.PENDING_COMPANY
                    });
                    return _ctx.abrupt("return", {
                        status: 'ok'
                    });
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};

var doSendCompanyForm = function(set, get) {
    return _asyncToGenerator(_app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, companyBusinessID, companyIdentificationConsent, companyName, companyCountry, companyAddress, companySales, sessionCode, companyRequestPayload, _ref, status, companyData, errorStatus, sessionStateID;
        return _app_www_server_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = get(), companyBusinessID = ref.companyBusinessID, companyIdentificationConsent = ref.companyIdentificationConsent, companyName = ref.companyName, companyCountry = ref.companyCountry, companyAddress = ref.companyAddress, companySales = ref.companySales, sessionCode = ref.sessionCode;
                    if (!(!companyBusinessID || !companyName || !companyCountry || !companyAddress || !companySales)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'bad request',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.companyFormInformationMissing",
                            defaultMessage: "T\xe4yt\xe4 kaikki kent\xe4t ennen lomakkeen l\xe4hett\xe4mist\xe4."
                        })
                    });
                case 3:
                    if (companyIdentificationConsent) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'company consent missing',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.companyFormConsentMissing",
                            defaultMessage: "Vakuus sy\xf6tetyn tiedon aitoudesta on pakollinen."
                        })
                    });
                case 5:
                    companyRequestPayload = {
                        businessID: companyBusinessID,
                        name: companyName,
                        country: companyCountry,
                        address: companyAddress,
                        sales: companySales,
                        sessionCode: sessionCode
                    };
                    _ctx.next = 8;
                    return (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .nextApiRequest */ .Qd)("/api/v1/www/register-company/company-form", companyRequestPayload, {
                        delay: 2000
                    });
                case 8:
                    _ref = _ctx.sent;
                    status = _ref.status;
                    companyData = _objectWithoutProperties(_ref, [
                        "status"
                    ]);
                    errorStatus = (0,_basicErrorHandling__WEBPACK_IMPORTED_MODULE_7__/* .handleBasicErrors */ .i)({
                        status: status
                    });
                    if (!errorStatus) {
                        _ctx.next = 14;
                        break;
                    }
                    return _ctx.abrupt("return", errorStatus);
                case 14:
                    if (!(status !== 'ok')) {
                        _ctx.next = 16;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        status: 'company form failed',
                        error: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "register.company.companyFormFailed",
                            defaultMessage: "Yrityksen liitt\xe4minen lomakkeella ep\xe4onnistui. Ole hyv\xe4 ja yrit\xe4 uudelleen…"
                        })
                    });
                case 16:
                    sessionStateID = companyData.sessionStateID;
                    // Save to state
                    set({
                        isCompanyLinkFormSent: true,
                        sessionStateID: sessionStateID
                    });
                    _ctx.next = 20;
                    return (0,_loginContext__WEBPACK_IMPORTED_MODULE_6__/* .validateSession */ .je)();
                case 20:
                    return _ctx.abrupt("return", {
                        status: 'ok'
                    });
                case 21:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};

/** Store */ var registerCompanyState = (0,zustand__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_10__/* .combine */ .$e)(registerCompanyStateDefaults, function(set, get) {
    return {
        /** State methods */ doClearState: doClearState(set, get),
        doIdentifyRedirect: doIdentifyRedirect(set, get),
        doIdentifyUser: doIdentifyUser(set, get),
        doLinkCompany: doLinkCompany(set, get),
        doSendIdentificationForm: doSendIdentificationForm(set, get),
        doSendCompanyForm: doSendCompanyForm(set, get),
        /** General set state */ set: set
    };
}));
/** State hook */ var useRegisterCompanyState = (/* unused pure expression or super */ null && (registerCompanyState));
/** All possbile link company steps */ var registerCompanySteps = (/* unused pure expression or super */ null && ([
    'review',
    'identification',
    'manual-identification',
    'link',
    'manual-link',
    'complete',
    'manual-complete',
    'login', 
]));
/** Hook to get current link company step programmatically */ var useRegisterCompanyStep = function(currentStep) {
    var ref = (0,_useUser__WEBPACK_IMPORTED_MODULE_5__/* .useUser */ .a)(), isLoggedIn = ref.isLoggedIn, companies = ref.companies, isSSRRender = ref.isSSRRender;
    var ref1 = (0,_lib_state__WEBPACK_IMPORTED_MODULE_3__/* .useScopedState */ .S)(registerCompanyState, [
        'sessionStateID'
    ]), sessionStateID = ref1.sessionStateID, set = ref1.set;
    // If the user has not logged in, redirect to login
    if (!isSSRRender && !isLoggedIn) return 'login';
    // Fallback to review step if user tries to go forward with multiple companies
    // TODO: Remove this step when multiple companies are implemented
    if (companies.length > 0 && ![
        'complete',
        'manual-complete'
    ].includes(currentStep)) return 'review';
    // If there are companies already linked to this account, show "review" step first
    if (companies.length > 0 && sessionStateID === _common_Constants__WEBPACK_IMPORTED_MODULE_4__/* .RegisterCompanySessionState.PENDING_AUTHENTICATION */ .w_.PENDING_AUTHENTICATION) {
        return [
            'manual-identification',
            'identification'
        ].includes(currentStep) ? currentStep : 'review';
    }
    // If user has not identified, show the identification step
    if (sessionStateID === _common_Constants__WEBPACK_IMPORTED_MODULE_4__/* .RegisterCompanySessionState.PENDING_AUTHENTICATION */ .w_.PENDING_AUTHENTICATION) {
        return currentStep === 'manual-identification' ? 'manual-identification' : 'identification';
    }
    // If company is not linked, show the link step
    if (sessionStateID === _common_Constants__WEBPACK_IMPORTED_MODULE_4__/* .RegisterCompanySessionState.PENDING_COMPANY */ .w_.PENDING_COMPANY) {
        // Clear the consent box when navigating to manual company form
        if (currentStep === 'manual-link') {
            set({
                companyIdentificationConsent: false
            });
        }
        return currentStep === 'manual-link' ? 'manual-link' : 'link';
    }
    // If manual forms were used, show the manual complete screen
    if (sessionStateID === _common_Constants__WEBPACK_IMPORTED_MODULE_4__/* .RegisterCompanySessionState.PENDING_REVIEW */ .w_.PENDING_REVIEW) {
        return 'manual-complete';
    }
    // If automated methods were used, show the "instant" complete screen
    if (sessionStateID === _common_Constants__WEBPACK_IMPORTED_MODULE_4__/* .RegisterCompanySessionState.ACCEPTED */ .w_.ACCEPTED) {
        return 'complete';
    }
    // Fallback to identification if something is off...
    return 'identification';
};


/***/ })

}]);